'use strict'

import $ from 'jquery';
import {CLASS_BOOTSTRAP_DISPLAY_NONE,CLASS_BOOTSTRAP_OVERFLOW_HIDDEN} from './helpers'
import { gsap } from 'gsap';

/**
 * Page header related functionality.
 */
const header = {

  /**
   * Initializes module. Adds event listeners and animations.
   */
  init: function () {

    // Event when hamburger menu is opened in mobile
    $('#mobile-menu').on('show.bs.collapse', () => {
      $('body').addClass(CLASS_BOOTSTRAP_OVERFLOW_HIDDEN);
      $('.back-button-wrapper-mobile .button-back').addClass(CLASS_BOOTSTRAP_DISPLAY_NONE);
      $('.menu-open,.menu-close').toggleClass(CLASS_BOOTSTRAP_DISPLAY_NONE);

      setTimeout(() => {
        gsap.to('.support-navigation li, .footer-links li, .follow-us, .languages', { autoAlpha: 1.0, top: 0, duration: 0.2 });
      }, 200);
    });

    // Event when hamburger menu is closed in mobile
    $('#mobile-menu').on('hidden.bs.collapse', (e) => {
      
      e.preventDefault();
      gsap.to('.support-navigation li, .footer-links li, .follow-us, .languages', { autoAlpha: 0, top: 10, duration: 0.2 });

      setTimeout(() => {
        $('body').removeClass(CLASS_BOOTSTRAP_OVERFLOW_HIDDEN);
        $('.back-button-wrapper-mobile .button-back').removeClass(CLASS_BOOTSTRAP_DISPLAY_NONE);
        $('.menu-open,.menu-close').toggleClass(CLASS_BOOTSTRAP_DISPLAY_NONE);
        $('#mobile-menu').collapse({ toggle: true }).removeClass('show');
      }, 200);

    });
  }
}

module.exports = header;